import { memo } from 'react';

import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { AdfoxContextProvider, AdfoxContextProviderProps } from '../../context/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 376 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'ddcfw', p2: 'fkhj' };

type TGBBannerProps = {
  position: number;
};

export const TGBBanner = memo<TGBBannerProps>(function TGBBanner(props) {
  const { position } = props;

  return (
    <AdfoxContextProvider pParams={P_PARAMS} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} size={SIZE}>
      <AdfoxBannerContainer position={position} />
    </AdfoxContextProvider>
  );
});
